var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62598 5.47368C9.62598 5.21207 9.85683 5 10.1416 5H11.8604C12.1451 5 12.376 5.21207 12.376 5.47368C12.376 5.73529 12.1451 5.94736 11.8604 5.94736H10.1416C9.85683 5.94736 9.62598 5.73529 9.62598 5.47368ZM11 16.0526C13.468 16.0526 15.4688 14.2147 15.4688 11.9474C15.4688 9.68017 13.468 7.8422 11 7.8422C8.53198 7.8422 6.53125 9.68017 6.53125 11.9474C6.53125 14.2147 8.53198 16.0526 11 16.0526ZM11 17C14.0376 17 16.5 14.7379 16.5 11.9474C16.5 9.37113 14.4011 7.2452 11.6884 6.93403V6.8947C11.6884 6.7203 11.5345 6.57891 11.3446 6.57891H10.6572C10.4673 6.57891 10.3134 6.7203 10.3134 6.8947V6.93383C7.59988 7.24425 5.5 9.37056 5.5 11.9474C5.5 14.7379 7.96243 17 11 17ZM15.1619 7.03907C15.0165 6.92697 14.7997 6.9444 14.6776 7.078C14.5556 7.2116 14.5746 7.41078 14.72 7.52289L15.2467 7.92885C15.3921 8.04096 15.6089 8.02353 15.7309 7.88993C15.853 7.75633 15.834 7.55715 15.6886 7.44504L15.1619 7.03907ZM14.7803 11.9474C14.7803 13.8658 13.0874 15.4211 10.9991 15.4211C8.91077 15.4211 7.21785 13.8658 7.21785 11.9474C7.21785 10.029 8.91077 8.47375 10.9991 8.47375C13.0874 8.47375 14.7803 10.029 14.7803 11.9474ZM11.6861 11.9473C11.6861 12.2961 11.3783 12.5789 10.9986 12.5789C10.6189 12.5789 10.3111 11.9473 10.3111 11.9473L9.27985 10.3684L10.9986 11.3158C10.9986 11.3158 11.6861 11.5985 11.6861 11.9473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingSessions);
export default __webpack_public_path__ + "static/media/TrainingSessions.89282ad72dd9b4fbdd6dd25b794aef1c.svg";
export { ForwardRef as ReactComponent };